/**
 * @generated SignedSource<<6c95e56f7f888d6f6dde317d52689e33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ZnglyContext_Styles_Fragment$data = {
  readonly znglyInfo: {
    readonly backendPrimaryColor: string | null | undefined;
    readonly backendSecondaryColor: string | null | undefined;
    readonly bodyDescBoxClr: string | null | undefined;
    readonly bodyDescBoxTxtClr: string | null | undefined;
    readonly catZnglistClr: string | null | undefined;
    readonly ctaPrimaryClr: string | null | undefined;
    readonly ctaPrimaryTxtClr: string | null | undefined;
    readonly ctaSecondaryClr: string | null | undefined;
    readonly ddBgClr: string | null | undefined;
    readonly ddPrimaryTxtClr: string | null | undefined;
    readonly ddSecondaryTxtClr: string | null | undefined;
    readonly fontStyle: string | null | undefined;
    readonly footerAccentClr: string | null | undefined;
    readonly footerBgClr: string | null | undefined;
    readonly footerPrimaryTxtClr: string | null | undefined;
    readonly footerSecondaryTxtClr: string | null | undefined;
    readonly headerBgClr: string | null | undefined;
    readonly headerPrimaryAccentClr: string | null | undefined;
    readonly headerPrimaryTxtClr: string | null | undefined;
    readonly headerSecondaryAccentClr: string | null | undefined;
    readonly headerSecondaryTxtClr: string | null | undefined;
    readonly pagePrimaryAccClr: string | null | undefined;
    readonly pagePrimaryTxtClr: string | null | undefined;
    readonly pageSecondaryAccClr: string | null | undefined;
    readonly pageSecondaryTxtClr: string | null | undefined;
    readonly readMorePrimaryClr: string | null | undefined;
    readonly readMorePrimaryTxtClr: string | null | undefined;
    readonly readMoreSecondaryClr: string | null | undefined;
    readonly shareBtnPrimaryClr: string | null | undefined;
    readonly shareBtnSecondaryClr: string | null | undefined;
    readonly userMenuBackgroundClr: string | null | undefined;
    readonly userMenuLinkClr: string | null | undefined;
    readonly userMenuLinkHoverClr: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ZnglyContext_Styles_Fragment";
};
export type ZnglyContext_Styles_Fragment$key = {
  readonly " $data"?: ZnglyContext_Styles_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ZnglyContext_Styles_Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ZnglyContext_Styles_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ZnglyInfo_Znglyinfo",
      "kind": "LinkedField",
      "name": "znglyInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headerPrimaryAccentClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headerPrimaryTxtClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headerBgClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backendPrimaryColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backendSecondaryColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "footerSecondaryTxtClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "footerPrimaryTxtClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "footerBgClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "footerAccentClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fontStyle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bodyDescBoxTxtClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bodyDescBoxClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headerSecondaryAccentClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headerSecondaryTxtClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pagePrimaryAccClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pagePrimaryTxtClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageSecondaryAccClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageSecondaryTxtClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userMenuBackgroundClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userMenuLinkClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userMenuLinkHoverClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "catZnglistClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ddBgClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ddPrimaryTxtClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ddSecondaryTxtClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "readMorePrimaryClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "readMoreSecondaryClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "readMorePrimaryTxtClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaPrimaryClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaSecondaryClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ctaPrimaryTxtClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shareBtnPrimaryClr",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shareBtnSecondaryClr",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ZnglyInfo",
  "abstractKey": null
};

(node as any).hash = "2397286ecbd67575001a247f8e8d2fbb";

export default node;
